export default function getInitials(name: string) {
	return name
		.toUpperCase()
		.split(/\s+/)
		.filter((letter, index, self) => index === 0 || index === self.length - 1)
		.map(str => str[0])
		.join('');
}
